import SharedBlockButtons from '../../BlockButtons';
import CreateBlockModal from './CreateBlockModal';

const BlockButtons = ({ selectedBlockId, onClick }) => {
  return (
    <SharedBlockButtons
      selectedBlockId={selectedBlockId}
      onClick={onClick}
      actions={<CreateBlockModal />}
    />
  );
};

export default BlockButtons;
